module.exports = "/resources/assets/prod/6b1fc6a66d6a8af7f802bbd8f6395eb3.svg";